import type { AdminPrivileges } from '../types/adminPrivilegeTypes';

// ─── Translations (EN → PL) ───────────────────────────────────────────────────

const translations: Record<string, string> = {
  'Select All': 'Zaznacz wszystko',

  // No PL translation from requirements — keeping EN
  'Admin User Management': 'Admin User Management',
  'Add Admin User': 'Add Admin User',
  'Edit Admin User': 'Edit Admin User',
  'List Admin Users': 'List Admin Users',
  'View Admin User Details': 'View Admin User Details',
  'Activate / Deactivate Admin User': 'Activate / Deactivate Admin User',

  // No PL translation from requirements — keeping EN
  'Subscription Management': 'Subscription Management',
  'Create Subscription': 'Create Subscription',
  'Edit Subscription': 'Edit Subscription',
  'List Subscriptions': 'List Subscriptions',
  'View Subscription Details': 'View Subscription Details',
  'Activate / Deactivate Subscription': 'Activate / Deactivate Subscription',

  // No PL translation from requirements — keeping EN
  'Offer Management': 'Offer Management',
  'Create Offer': 'Create Offer',
  'Edit Offer': 'Edit Offer',
  'List Offers': 'List Offers',
  'View Offer Details': 'View Offer Details',
  'Activate / Deactivate Offer': 'Activate / Deactivate Offer',

  // No PL translation from requirements — keeping EN
  'Client Management': 'Client Management',
  'Create Client': 'Create Client',
  'Edit Client': 'Edit Client',
  'List Clients': 'List Clients',
  'View Client Details': 'View Client Details',
  'Activate / Deactivate Client': 'Activate / Deactivate Client',

  'Facility Management': 'Zarządzanie placówkami',
  'Add Facility': 'Tworzenie placówki',
  'Edit Facility': 'Edycja placówki',
  'View List of Facilities': 'Lista placówek',
  'View Specific Facility Details': 'Podgląd szczegółów placówki',
  'Activate / Deactivate Facility': 'Activate / Deactivate Facility',

  'Equipment Management': 'Zarządzanie aparaturą',
  'Add Equipment': 'Dodaj aparaturę',
  'Edit Equipment Details': 'Edycja danych aparatury',
  'View Equipment List': 'Lista aparatury',
  'View Equipment Details': 'Podgląd danych aparatury',

  'Employee Management': 'Zarządzanie pracownikami',
  'List Facility Users': 'Lista pracowników',
  'View Facility User Details': 'Podgląd danych pracownika',

  // No PL translation from requirements — keeping EN
  'Technician Management': 'Technician Management',
  'Create Technician': 'Create Technician',
  'Edit Technician': 'Edit Technician',
  'List Technicians': 'List Technicians',
  'View Technician Details': 'View Technician Details',
  'Activate / Deactivate Technician': 'Activate / Deactivate Technician',

  // No PL translation from requirements — keeping EN
  'Task Form Template Management': 'Task Form Template Management',
  'List of Task Form Templates': 'List of Task Form Templates',
  'Add Task Form Template': 'Add Task Form Template',
  'Edit Task Form Template': 'Edit Task Form Template',
  'View Task Form Template': 'View Task Form Template',

  // No PL translation from requirements — keeping EN
  'Certificate Template Management': 'Certificate Template Management',
  'Add Certificate Template': 'Add Certificate Template',
  'Edit Certificate Template': 'Edit Certificate Template',
  'List of Certificate Templates': 'List of Certificate Templates',
  'View Certificate Template Details': 'View Certificate Template Details',

  // No PL translation from requirements — keeping EN
  'Certificate Management': 'Certificate Management',
  'List of Certificate Generated': 'List of Certificate Generated',
  'View Certificate Details': 'View Certificate Details',
  'View & Download Certificate': 'View & Download Certificate',

  // No PL translation from requirements — keeping EN
  'Service Type Management': 'Service Type Management',
  'Create Service Type': 'Create Service Type',
  'Edit Service Type': 'Edit Service Type',
  'List of Service Types': 'List of Service Types',
  'View Service Type': 'View Service Type',
  'Activate / Deactivate Service Type': 'Activate / Deactivate Service Type',

  // No PL translation from requirements — keeping EN
  'Service Request Management': 'Service Request Management',
  'View Service Request List': 'View Service Request List',
  'View Service Request Details': 'View Service Request Details',
  'Assign / Schedule Service Requests': 'Assign / Schedule Service Requests',
  'Update Service Request Status': 'Update Service Request Status',
  'Reschedule Service Request': 'Reschedule Service Request',
  'Accept / Reject Service Request': 'Accept / Reject Service Request',

  // No PL translation from requirements — keeping EN
  'Contact Request Management': 'Contact Request Management',
  'List of Contact Requests': 'List of Contact Requests',
  'View Specific Contact Request': 'View Specific Contact Request',
  'Assign Contact Requests': 'Assign Contact Requests',
  'Update Contact Request Status': 'Update Contact Request Status',
  'Accept / Reject Contact Request': 'Accept / Reject Contact Request',
  'Reschedule Contact Requests': 'Reschedule Contact Requests',

  // No PL translation from requirements — keeping EN
  'Invoice Template Management': 'Invoice Template Management',
  'Add Invoice Template': 'Add Invoice Template',
  'Edit Invoice Template': 'Edit Invoice Template',
  'List of Invoice Templates': 'List of Invoice Templates',
  'View Invoice Template': 'View Invoice Template',
  'Activate / Deactivate Invoice Template':
    'Activate / Deactivate Invoice Template',

  // No PL translation from requirements — keeping EN
  'Invoice Management': 'Invoice Management',
  'List of Draft Invoices': 'List of Draft Invoices',
  'View Draft Invoice Details': 'View Draft Invoice Details',
  'Edit Draft Invoice Details': 'Edit Draft Invoice Details',
  'Update Invoice Status': 'Update Invoice Status',
  'Lista faktur': 'Lista faktur',
  'Podgląd faktury': 'Podgląd faktury',
  'View & Download Invoice': 'View & Download Invoice',

  // No PL translation from requirements — keeping EN
  'QMS Document Category Management': 'QMS Document Category Management',
  'List of Categories': 'List of Categories',
  'Create Category': 'Create Category',
  'Edit Category': 'Edit Category',
  'View Category Details': 'View Category Details',
  'Activate / Deactivate Category': 'Activate / Deactivate Category',

  // No PL translation from requirements — keeping EN
  'QMS Document Template Management': 'QMS Document Template Management',
  'List of Templates': 'List of Templates',
  'Create Template': 'Create Template',
  'Edit Template': 'Edit Template',
  'View Template Details': 'View Template Details',
  'Activate / Deactivate Template': 'Activate / Deactivate Template',

  // No PL translation from requirements — keeping EN
  'QMS Document Update Requests': 'QMS Document Update Requests',
  'List of Client Requests': 'List of Client Requests',
  'View Client Request Details': 'View Client Request Details',
  'Edit Request': 'Edit Request',
  'Update Document Status': 'Update Document Status',

  // No PL translation from requirements — keeping EN
  'Other Modules': 'Other Modules',
  Dashboard: 'Dashboard',
  'Export Reports': 'Export Reports',
};

export const tAdmin = (key: string): string => translations[key] ?? key;

const apiDomain = (import.meta.env['VITE_API_DOMAIN_NAME'] as string) ?? '';
export const showAdminLangToggle =
  import.meta.env.DEV || apiDomain.includes('dev') || apiDomain.includes('qa');

// ─── Module config ────────────────────────────────────────────────────────────

export interface ModuleItem {
  key: keyof AdminPrivileges;
  label: string;
}

export interface ModuleConfig {
  id: string;
  title: string;
  items: ModuleItem[];
}

// Mirrors ADMIN_PRIVILEGE_CATALOG from
// lib/authorization/types/admin_privilege.types.ts.
// Labels are the English names from the catalog — keep in sync when modules change.
export const ADMIN_MODULES: ModuleConfig[] = [
  {
    id: 'admin_user_management',
    title: 'Admin User Management',
    items: [
      { key: 'adminUserList', label: 'List Admin Users' },
      { key: 'adminUserCreate', label: 'Add Admin User' },
      { key: 'adminUserEdit', label: 'Edit Admin User' },
      { key: 'adminUserView', label: 'View Admin User Details' },
      {
        key: 'adminUserActivateDeactivate',
        label: 'Activate / Deactivate Admin User',
      },
    ],
  },
  {
    id: 'subscription_management',
    title: 'Subscription Management',
    items: [
      { key: 'subscriptionList', label: 'List Subscriptions' },
      { key: 'subscriptionCreate', label: 'Create Subscription' },
      { key: 'subscriptionEdit', label: 'Edit Subscription' },
      { key: 'subscriptionView', label: 'View Subscription Details' },
      {
        key: 'subscriptionActivateDeactivate',
        label: 'Activate / Deactivate Subscription',
      },
    ],
  },
  {
    id: 'offer_management',
    title: 'Offer Management',
    items: [
      { key: 'offerList', label: 'List Offers' },
      { key: 'offerCreate', label: 'Create Offer' },
      { key: 'offerEdit', label: 'Edit Offer' },
      { key: 'offerView', label: 'View Offer Details' },
      { key: 'offerActivateDeactivate', label: 'Activate / Deactivate Offer' },
    ],
  },
  {
    id: 'client_management',
    title: 'Client Management',
    items: [
      { key: 'clientList', label: 'List Clients' },
      { key: 'clientCreate', label: 'Create Client' },
      { key: 'clientUpdate', label: 'Edit Client' },
      { key: 'clientView', label: 'View Client Details' },
      {
        key: 'clientActivateDeactivate',
        label: 'Activate / Deactivate Client',
      },
    ],
  },
  {
    id: 'facility_management',
    title: 'Facility Management',
    items: [
      { key: 'facilityList', label: 'View List of Facilities' },
      { key: 'facilityCreate', label: 'Add Facility' },
      { key: 'facilityEdit', label: 'Edit Facility' },
      { key: 'facilityView', label: 'View Specific Facility Details' },
      {
        key: 'facilityActivateDeactivate',
        label: 'Activate / Deactivate Facility',
      },
    ],
  },
  {
    id: 'equipment_management',
    title: 'Equipment Management',
    items: [
      { key: 'equipmentList', label: 'View Equipment List' },
      { key: 'equipmentCreate', label: 'Add Equipment' },
      { key: 'equipmentEdit', label: 'Edit Equipment Details' },
      { key: 'equipmentView', label: 'View Equipment Details' },
    ],
  },
  {
    id: 'facility_user_management',
    title: 'Employee Management',
    items: [
      { key: 'facilityUserList', label: 'List Facility Users' },
      { key: 'facilityUserView', label: 'View Facility User Details' },
    ],
  },
  {
    id: 'technician_management',
    title: 'Technician Management',
    items: [
      { key: 'technicianList', label: 'List Technicians' },
      { key: 'technicianCreate', label: 'Create Technician' },
      { key: 'technicianEdit', label: 'Edit Technician' },
      { key: 'technicianView', label: 'View Technician Details' },
      {
        key: 'technicianActivateDeactivate',
        label: 'Activate / Deactivate Technician',
      },
    ],
  },
  {
    id: 'form_template_management',
    title: 'Task Form Template Management',
    items: [
      { key: 'formTemplateList', label: 'List of Task Form Templates' },
      { key: 'formTemplateCreate', label: 'Add Task Form Template' },
      { key: 'formTemplateEdit', label: 'Edit Task Form Template' },
      { key: 'formTemplateView', label: 'View Task Form Template' },
    ],
  },
  {
    id: 'certificate_template_management',
    title: 'Certificate Template Management',
    items: [
      {
        key: 'certificateTemplateList',
        label: 'List of Certificate Templates',
      },
      { key: 'certificateTemplateCreate', label: 'Add Certificate Template' },
      { key: 'certificateTemplateEdit', label: 'Edit Certificate Template' },
      {
        key: 'certificateTemplateView',
        label: 'View Certificate Template Details',
      },
    ],
  },
  {
    id: 'certificate_management',
    title: 'Certificate Management',
    items: [
      { key: 'certificateList', label: 'List of Certificate Generated' },
      { key: 'certificateView', label: 'View Certificate Details' },
      { key: 'certificateDownload', label: 'View & Download Certificate' },
    ],
  },
  {
    id: 'service_type_management',
    title: 'Service Type Management',
    items: [
      { key: 'serviceTypeList', label: 'List of Service Types' },
      { key: 'serviceTypeCreate', label: 'Create Service Type' },
      { key: 'serviceTypeEdit', label: 'Edit Service Type' },
      { key: 'serviceTypeView', label: 'View Service Type' },
      {
        key: 'serviceTypeActivateDeactivate',
        label: 'Activate / Deactivate Service Type',
      },
    ],
  },
  {
    id: 'service_request_management',
    title: 'Service Request Management',
    items: [
      { key: 'serviceRequestList', label: 'View Service Request List' },
      { key: 'serviceRequestView', label: 'View Service Request Details' },
      {
        key: 'serviceRequestAssign',
        label: 'Assign / Schedule Service Requests',
      },
      {
        key: 'serviceRequestUpdateStatus',
        label: 'Update Service Request Status',
      },
      {
        key: 'serviceRequestAcceptReject',
        label: 'Accept / Reject Service Request',
      },
      { key: 'serviceRequestReschedule', label: 'Reschedule Service Request' },
    ],
  },
  {
    id: 'contact_request_management',
    title: 'Contact Request Management',
    items: [
      { key: 'contactRequestList', label: 'List of Contact Requests' },
      { key: 'contactRequestView', label: 'View Specific Contact Request' },
      { key: 'contactRequestAssign', label: 'Assign Contact Requests' },
      {
        key: 'contactRequestUpdateStatus',
        label: 'Update Contact Request Status',
      },
      {
        key: 'contactRequestAcceptReject',
        label: 'Accept / Reject Contact Request',
      },
      { key: 'contactRequestReschedule', label: 'Reschedule Contact Requests' },
    ],
  },
  {
    id: 'invoice_template_management',
    title: 'Invoice Template Management',
    items: [
      { key: 'invoiceTemplateList', label: 'List of Invoice Templates' },
      { key: 'invoiceTemplateCreate', label: 'Add Invoice Template' },
      { key: 'invoiceTemplateEdit', label: 'Edit Invoice Template' },
      { key: 'invoiceTemplateView', label: 'View Invoice Template' },
      {
        key: 'invoiceTemplateActivateDeactivate',
        label: 'Activate / Deactivate Invoice Template',
      },
    ],
  },
  {
    id: 'invoice_management',
    title: 'Invoice Management',
    items: [
      { key: 'invoiceDraftList', label: 'List of Draft Invoices' },
      { key: 'invoiceDraftView', label: 'View Draft Invoice Details' },
      { key: 'invoiceDraftEdit', label: 'Edit Draft Invoice Details' },
      { key: 'invoicePublish', label: 'Update Invoice Status' },
      { key: 'invoiceList', label: 'List Invoice' },
      { key: 'invoiceView', label: 'View Invoice' },
      { key: 'invoiceDownload', label: 'Download Invoice' },
    ],
  },
  {
    id: 'qms_doc_category_management',
    title: 'QMS Document Category Management',
    items: [
      { key: 'qmsDocCategoryList', label: 'List of Categories' },
      { key: 'qmsDocCategoryCreate', label: 'Create Category' },
      { key: 'qmsDocCategoryEdit', label: 'Edit Category' },
      { key: 'qmsDocCategoryView', label: 'View Category Details' },
      {
        key: 'qmsDocCategoryActivateDeactivate',
        label: 'Activate / Deactivate Category',
      },
    ],
  },
  {
    id: 'qms_doc_template_management',
    title: 'QMS Document Template Management',
    items: [
      { key: 'qmsDocTemplateList', label: 'List of Templates' },
      { key: 'qmsDocTemplateCreate', label: 'Create Template' },
      { key: 'qmsDocTemplateEdit', label: 'Edit Template' },
      { key: 'qmsDocTemplateView', label: 'View Template Details' },
      {
        key: 'qmsDocTemplateActivateDeactivate',
        label: 'Activate / Deactivate Template',
      },
    ],
  },
  {
    id: 'qms_update_requests',
    title: 'QMS Document Update Requests',
    items: [
      { key: 'qmsUpdateRequestList', label: 'List of Client Requests' },
      { key: 'qmsUpdateRequestEdit', label: 'Edit Request' },
      { key: 'qmsUpdateRequestView', label: 'View Client Request Details' },
      { key: 'qmsUpdateRequestUpdateStatus', label: 'Update Document Status' },
    ],
  },
  {
    id: 'other',
    title: 'Other Modules',
    items: [
      { key: 'dashboardView', label: 'Dashboard' },
      { key: 'exportReports', label: 'Export Reports' },
    ],
  },
];
